import './index.css';
const getChecked = (currentValue, selectedValues) => Array.isArray(selectedValues)
    ? !!selectedValues.find((item) => item.value === currentValue.value)
    : selectedValues.value === currentValue.value;

export { getChecked };
//# sourceMappingURL=getChecked.js.map
